import { takeEvery, put, select } from 'redux-saga/effects';
import { getLocation, LOCATION_CHANGE, replace } from 'connected-react-router';
import { manaFiatGatewayPurchaseCompleted } from '../gateway/actions';
export function* locationSaga() {
    yield takeEvery(LOCATION_CHANGE, handleLocationChange);
}
function* handleLocationChange(_action) {
    const { query } = yield select(getLocation);
    const { network, gateway, transactionId, transactionStatus } = query;
    if (transactionId && transactionStatus && network && gateway) {
        const queryParams = new URLSearchParams(query);
        const params = ['transactionId', 'transactionStatus', 'network', 'gateway'];
        params.forEach(param => queryParams.delete(param));
        yield put(replace(`${location.pathname}?${queryParams.toString()}`));
        yield put(manaFiatGatewayPurchaseCompleted(network, gateway, transactionId, transactionStatus));
    }
}
//# sourceMappingURL=sagas.js.map